import { isDetailedExpenses } from "web_myplann/Finances/Helpers/isDetailedExpenses";
import { isDetailedIncome } from "web_myplann/Finances/Helpers/isDetailedIncome";
import { sumIncomeAmounts } from "web_myplann/Finances/Helpers/sumIncomeAmounts";
import { sumMonthlyPayments } from "web_myplann/Finances/Helpers/sumMonthlyPayments";
import type { FinanceState } from "web_myplann/Finances/State/FinanceAtom";

export const mapComparableFinances = ({ income, expenses }: FinanceState) => ({
	income: isDetailedIncome(income) ? income : sumIncomeAmounts(income),
	expenses: isDetailedExpenses(expenses)
		? expenses
		: sumMonthlyPayments(expenses),
});
